class QuickShop extends HTMLElement {
    constructor() {
        super();
        let self = document.querySelector("quick-shop");
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        self.querySelector('#QuickShop-Overlay').addEventListener('click', this.close.bind(this));
        this.bindBtnEvents();
    }
    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    openingAnimations() {
        setTimeout(() => { this.classList.add('animate', 'active') });
        this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('QuickShop');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
        }, { once: true });

        document.body.classList.add('overflow-hidden')
    }

    async open(triggeredBy) {
        let _this = this;
        if (triggeredBy) {
            //console.log(this);
            document.querySelector("quick-shop").querySelector("quick-shop-item").innerHTML = "";
            document.querySelector("quick-shop").setActiveElement(triggeredBy.currentTarget);
            let productHandle = triggeredBy.currentTarget.getAttribute("data-product-handle");
            await fetch(`${window.Shopify.routes.root}products/${productHandle}?view=quick-shop`, {
                method: 'GET',
                headers: { "Content-type": "application/json; charset=UTF-8" },
            }).then(res => res.text()).then((response) => {
                let parser = new DOMParser();
                let productContent = parser.parseFromString(response, 'text/html');
                let viewProd=document.querySelector("quick-shop").querySelector('.view_product')
                //console.log(productContent.querySelector(".Quickshop__item-wrapper"));
                document.querySelector("quick-shop").querySelector("quick-shop-item").insertAdjacentElement("beforeend", productContent.querySelector(".Quickshop__item-wrapper"));
                if(viewProd != null) viewProd.setAttribute('href', `/products/${productHandle}`)
                eval(document.querySelector("quick-shop").querySelector("quick-shop-item").querySelector("script[data-slider]").innerHTML);
                document.querySelector("quick-shop").openingAnimations();
                document.querySelector("quick-shop").bindEvents();
                
                window.customSelectClickEvent();

            });
        }
    }
    setActiveElement(element) {
        this.activeElement = element;
    }

    bindBtnEvents() {
        let _this = this;
        let quickShopBtns = document.querySelectorAll(".quick-shop-btn:not(.js-bind)");
        if (quickShopBtns.length) {
            quickShopBtns.forEach((quickShopBtn) => {
                quickShopBtn.classList.add("js-bind");
                quickShopBtn.addEventListener("click", function (e) {
                    _this.open(e);
                });
            });
        }
    }

    bindEvents() {
        let _this = this;
        let productGridSwatch = this.querySelectorAll(".swatch-btn-image");
        let productGridSelectedSwatch = this.querySelectorAll(".color_variants_item.swatch-active .swatch-btn-image");
        if (productGridSwatch.length) {
            productGridSwatch.forEach((swatch) => {
                swatch.addEventListener("click", _this._handleSwatchClick.bind(this), true);
            });
        }
        // if (productGridSelectedSwatch.length) {
        //     productGridSelectedSwatch.forEach((swatch) => {
        //         swatch.closest('.card__content').querySelector('.js-selected-color-label').innerText = swatch.dataset.title;
        //     });
        // }
    }
    _handleSwatchClick(e) {
        let target = e.target || e.currentTarget;
        let productObject = target.closest(".swatch-wrapper").querySelector("script[data-json]").innerHTML;
        if (!productObject) return;
        let productJson = JSON.parse(productObject);
        target.closest(".color_variants_main_product").querySelectorAll(".color_variants_item").forEach((swatchElement) => {
            swatchElement.classList.remove("swatch-active");
        });
        target.closest(".color_variants_item").classList.add("swatch-active");
        this._handleProduct(target, productJson);
        this._handleImageChange(target, productJson);
        this._handlePriceChange(target, productJson);
    }
    _handleProduct(target, productJson) {
        if (!productJson) return;
        target.closest("form").querySelector(".Quickshop_item-title").setAttribute("href", `${window.Shopify.routes.root}products/${productJson.handle}`);
        target.closest("form").querySelector(".Quickshop_item-title").innerHTML = productJson.title;
        target.closest("form").querySelector(".Quickshop_item-link").setAttribute("href", `${window.Shopify.routes.root}products/${productJson.handle}`);
        // target.closest("form").querySelector(".Quickshop_item-link").innerHTML = productJson.title;

        // Build Size Dropdown
        //console.log(this);
        console.log(productJson);
        // let options = productJson.options;
        // let productOptionsSeparator = {};
        // for (let i = 0; i < options.length; i++) {
        //     options[i] = ((options[i]).toString()).toLowerCase();
        //     productOptionsSeparator[options[i]] = new Set();
        //     for (let variant of productJson.variants) {
        //         productOptionsSeparator[options[i]].add(variant[`option${i + 1}`]);
        //     }
        //     productOptionsSeparator[options[i]] = [...productOptionsSeparator[options[i]]];
        // }
        // console.log(productOptionsSeparator);

        // for (let option in productOptionsSeparator) {
        //     console.log(option);
        //     if (option == "size") {

        //     }
        // }
        document.querySelector("quick-shop").querySelector("quick-shop-item").innerHTML = "";
        let productHandle = productJson.handle;
        fetch(`${window.Shopify.routes.root}products/${productHandle}?view=quick-shop`, {
            method: 'GET',
            headers: { "Content-type": "application/json; charset=UTF-8" },
        }).then(res => res.text()).then((response) => {
            let parser = new DOMParser();
            let productContent = parser.parseFromString(response, 'text/html');
            document.querySelector("quick-shop").querySelector("quick-shop-item").insertAdjacentElement("beforeend", productContent.querySelector(".Quickshop__item-wrapper"));
            eval(document.querySelector("quick-shop").querySelector("quick-shop-item").querySelector("script[data-slider]").innerHTML);
            document.querySelector("quick-shop").openingAnimations();
            document.querySelector("quick-shop").bindEvents();

        });
    }
    _handleImageChange(target, productJson) {
        let _variantId = parseInt(target.getAttribute("data-variant-id"));
        let selectedVariant;
        for (let variant of productJson.variants) {
            if (variant.id == _variantId) {
                selectedVariant = variant;
            }
        }
        // target.closest("form").querySelector(".card__media .media").innerHTML = ""
        // let mediaHTML = "";
        let firstMediaSrc = selectedVariant.featured_image ? selectedVariant.featured_image : productJson.media[0].preview_image;
        // mediaHTML += `<img class="media__first-image" height="${firstMediaSrc.height}" width="${firstMediaSrc.width}" src="${firstMediaSrc.src}" alt="${firstMediaSrc.alt ? firstMediaSrc.alt : productJson.title}" />`;
        target.closest("form").querySelector(".Quickshop_item-image").src = firstMediaSrc.src;
    }
    _handlePriceChange(target, productJson) {
        let _variantId = parseInt(target.getAttribute("data-variant-id"));
        for (let variant of productJson.variants) {
            if (variant.id === _variantId) {
                target.closest("form").querySelector(".Quickshop_item-price--original-price").innerHTML = Shopify.formatMoney(variant.price, Shopify.money_format)
                break;
            }
        }
    }
}

customElements.define('quick-shop', QuickShop);
